<template>
  <div>
    <div class="card">
      <p class="detail">
        <strong>{{ $t("user.mine.address") }}: </strong>
        <span
          class="copy"
          v-clipboard="wallets.address"
          v-clipboard:success="clipboardSuccessHandler"
          v-clipboard:error="clipboardErrorHandler"
          >{{ wallets.address }}</span
        >
      </p>
      <p class="detail">
        <strong>{{ $t("user.mine.balance") }}: </strong>
        <span class="val">{{ balance.available || 0 }} </span
        ><strong> MASS</strong> &nbsp; &nbsp; &nbsp;
        <span class="grey" v-if="balance.all != balance.available">
          <strong>{{ $t("user.mine.balance_frozen") }}:</strong>
          {{ balance.all - balance.available }} <strong> MASS</strong></span
        >
      </p>
    </div>
    <div class="property card">
      <div class="card-tltle d-xs-none" >
        <img src="@/assets/image/book.png" />{{ $t("home.property") }}
      </div>
      <div class="inner">
        <div
          class="card-item"
          v-for="(item, i) in transaction.results"
          :key="i"
          @click="
            showTransaction(
              item.tx_id,
              item.amount,
              item.confirmed,
              item.direction
            )
          "
        >
          <div class="line d-flex justify-sb">
            <div class="left">
              
              
              <div class="title">
                <span class="label-text">{{$t('home.components.transaction.type')}}: </span>
                <span class="text">{{
                  item.direction == "income" ? $t("home.in") : $t("home.out")
                }}
                </span>
              </div>
              <span class="label-text">{{$t('home.components.transaction.status')}}: </span>
              <span :class="item.confirmed ? 'green' : 'red'">
                {{
                  item.confirmed
                    ? $t("home.state.success")
                    : $t("home.state.comfirming")
                }}
              </span>
            </div>
            <div class="midl">
              <div>
                <span class="label-text">{{$t('home.components.transaction.amount')}}: </span>
                <span
                  class="num text"
                  :class="item.direction == 'income' ? 'in' : 'out'"
                >
                  {{ item.direction == "income" ? "+" : "-"
                  }}{{ item.amount }} MASS
                </span>
                <span class="date"> <span class="label-text">{{$t('home.components.transaction.time')}}: </span>{{ item.time | formatTime }}</span>
              </div>
              <div class="txid"><span class="label-text">TXID：</span><span class="text">{{ item.tx_id }}</span></div>
            </div>
            <!-- "height":"交易高度",
      "time":"交易时间",
      "type": "交易类型",
      "status": "交易状态",
      "amount": "交易金额（MASS）" -->
            <div class="midr block"> <span class="label-text">{{$t('home.components.transaction.height')}}: </span><span class="text">{{ item.block_height | trans }}</span></div>
            <div class="right">
              <a class="explore" :href="$explorer + 'tx/' + item.tx_id">
                <img
                  :title="$t('home.toExplorer')"
                  width="10rem"
                  src="@/assets/image/explore.png"
                />
              </a>
            </div>
          </div>
        </div>
      </div>
      <Pagination
        class="pagin d-xs-none"
        :currentPage="currentPage"
        :totalPages="pages"
        @goto="goto"
      />
      <MBPagination class="pagin d-none d-xs-block "  :currentPage="currentPage"
        :totalPages="pages" @goto="goto"/>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import moment from "moment";

import {Transaction} from "./components";
import Pagination from "@/components/Pagination";
import MBPagination from "@/components/MBPagination";
export default {
  name: "trade",
  meta: {
    authorization: true,
  },
  data() {
    return {
      currentPage: 1,
      limit: 10,
      mateMask: {
        address: "--",
        amount: "0",
      },
      web3: null,
      loading: false,
    };
  },
  components: {
    Pagination,
    MBPagination
  },
  computed: {
    ...mapState("wallet", ["transaction", "balance", "wallets"]),
    pages() {
      return this.transaction.page_count;
    },
  },
  filters: {
    formatTime(val) {
      const zone = 8 * 60 * 60 * 1000;
      return moment(new Date(val + zone)).format("YYYY-MM-DD HH:mm");
    },
    trans(val) {
      return val >= 0 ? val : "-";
    },
  },
  methods: {
    ...mapActions("wallet", [
      "getWallets",
      "getTransaction",
      "getBalance",
      "getTransactionItem",
    ]),
    ...mapActions("user", ["walletLogin"]),
    clipboardSuccessHandler() {
      this.$tooltip.success(this.$t("home.components.transIn.success"));
    },
    clipboardErrorHandler() {
      this.$tooltip.success(this.$t("home.components.transIn.fail"));
    },
    goto(page) {
      this.currentPage = page;
      this.getTransaction({ page: page, size: this.limit });
    },
    async showTransaction(id, amount, flag, income) {
      if (flag) {
        this.$modal.show({
          component: <Transaction id={id} amount={amount} income={income} />,
          close: () => {
            console.log("close");
          },
        });
      } else {
        this.$tooltip.info(this.$t("home.state.comfirming"));
      }
    },
  },
  async mounted() {
    this.$store.commit("wallet/SET_TRANSACTION", []);
    try {
      await this.getWallets();
    } catch (e) {
      this.$router.push({ name: "createWallet" });
    }
    await this.getTransaction({ page: this.currentPage, size: this.limit });
    await this.getBalance();
  },
};
</script>
<style lang="scss" scoped>
.property {
  margin-top: 20px;
  .line {
    padding: 15px 0;
    border-bottom: 1px solid #dedede;
  }
  .title {
    font-size: 16px;
    font-weight: bold;
    color: #333333;
    margin-bottom: 16px;
    line-height: 22px;
  }
  .green {
    display: inline-block;
    background: #7dc034;
    border-radius: 2px;
    font-size: 12px;
    font-weight: bold;
    color: #ffffff;
    line-height: 12px;
    padding: 5px;
  }
  .red {
    display: inline-block;
    background: #c03f34;
    border-radius: 2px;
    font-size: 12px;
    font-weight: bold;
    color: #ffffff;
    line-height: 12px;
    padding: 5px;
  }
  .num {
    font-size: 16px;
    font-weight: bold;
    display: inline-block;
    line-height: 22px;
    width: 200px;
    &.in {
      color: #3c9b35;
    }
    &.out {
      color: #d0021b;
    }
  }
  .midl {
    flex: 0.65;
  }
  .date,
  .block {
    font-size: 16px;
    font-weight: 400;
    color: rgba(51, 51, 51, 0.7);
    line-height: 22px;
  }
  .txid {
    font-size: 14px;
    font-weight: bold;
    color: rgba(51, 51, 51, 0.7);
    line-height: 14px;
    margin-top: 18px;
  }
}
.pagin {
  justify-content: flex-end;
}
.detail {
  font-size: 14px;
  color: #080807;
  line-height: 14px;
  margin: 20px 0;
  .val {
    font-size: 14px;
    font-weight: 400;
    color: var(--main-color);
    line-height: 14px;
  }
}
.copy {
  cursor: pointer;
  text-decoration: underline;
  word-break: break-all;
}
.label-text{
  display: none;
}
@media screen and (max-width: 768px) {
  .detail {
    line-height: 1.5;
    display: flex;
    strong {
      width: 70px;
      flex-shrink: 0;
    }
    strong:lang(en):first-child {
      width: 125px;
      text-align: right;
      margin-right: 10px;
    }
    .val {
      line-height: inherit;
      margin-right: 5px;
    }
  }
  .line{
    display: block;
    .right{
      display: none;
    }
    .txid{
      word-break: break-all;
    }
    .date{
      display: none;
    }
    .title ,.green, .txid{
      margin-bottom: 10px;
    }
    .txid{
      margin-top: 10px;
    }
  }
  .card-item:last-child{
    .line{
      border: none;
    }
  }
  .label-text{
     display: inline;
    font-size: 14px;
    font-weight: bold;
    color: #080807;
    line-height: 14px;
  }
  .text{
    font-size: 14px;
    font-weight: 400;
    color: #060606;
    line-height: 14px;
  }
  .property .green{
    background: transparent;
    color: #7dc034;
    font-size: 14px;
  }
  .property .red{
    background: transparent;
    color: #c03f34;
    font-size: 14px;
  }
}
</style>
